import React from 'react';

import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { createPortal } from 'react-dom';
import classes from './Modal.module.scss';

export type ModalProps = {
    title?: string;
    open?: boolean;
    footer?: React.ReactNode;
    children?: React.ReactNode;
    className?: string;
    headerClassName?: string;
    bodyClassName?: string;
    footerClassName?: string;
    onClose?: () => void;
};

const Modal: React.FC<ModalProps> = props => {
    return createPortal(
        <div
            className={classes.root}
            data-open={!!props.open}
            onClick={e => {
                if (e.target === e.currentTarget && props.onClose) {
                    props.onClose();
                }
            }}
        >
            <div
                className={clsx(classes.wrapper, props.className)}
                onClick={e => e.stopPropagation()}
            >
                <div
                    className={classes.modal}
                    data-has-footer={!!props.footer}
                    data-has-body={!!props.children}
                >
                    <div className={clsx(classes.header, props.headerClassName)}>
                        {props.title && <p className={classes.title}>{props.title}</p>}

                        <button type="button" className={classes.close} onClick={props.onClose}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>

                    <div className={clsx(classes.body, props.bodyClassName)}>{props.children}</div>

                    {props.footer && (
                        <div className={clsx(classes.footer, props.footerClassName)}>
                            {props.footer}
                        </div>
                    )}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default Modal;
